module.exports = __webpack_public_path__ + "static/media/upcoming-black.3927529f.svg";